// Рекламный бюджет — баланс рекламного кабинета + прогноз дней

export type AdBalanceError = 'NO_YANDEX_AUTH' | 'YANDEX_UNAVAILABLE'

export interface AdBalance {
  amount: number | null
  daysRemaining: number | null
  avgDailySpend: number | null
  source: 'yandex_direct' | 'mock' | 'fallback'
  error?: AdBalanceError
  updatedAt: string
}

const USE_MOCKS = false

export async function getAdBalance(channelUUID: string): Promise<AdBalance> {
  if (USE_MOCKS) {
    await new Promise((r) => setTimeout(r, 200))
    return {
      amount: 12480,
      daysRemaining: 8,
      avgDailySpend: 1560,
      source: 'mock',
      updatedAt: new Date().toISOString(),
    }
  }
  const res = await fetch(`/api/max/dashboard/balance?channelUUID=${encodeURIComponent(channelUUID)}`, {
    credentials: 'include',
  })
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
